const problemPatient = (memberId, visit) => {
  const consultId = visit.consultationId;
  window.open(`${memberId}/problem_patient?consultation_id=${consultId}`);
  return true;
};

export default problemPatient;
